<app-header></app-header>
<div class="main-container d-flex">
  <app-sidebar></app-sidebar>
  <div class="h-100p w-100 wc-result-main">
    <div class="wc-result-container">
      <div *ngIf="isLoading" class="wc-loading">
        <div class="spinner-border" role="status"></div>
        <p>Loading capture results…</p>
      </div>

      <div *ngIf="!isLoading && noResultsFound" class="wc-no-results-wrap">
        <div class="wc-header">
          <button type="button" class="wc-back-box" (click)="onBack()">
            <i class="bi bi-arrow-left"></i> Back
          </button>
        </div>
        <div class="wc-card wc-no-results">
          <i class="fas fa-search wc-no-results-icon" aria-hidden="true"></i>
          <h3>No Search Results Found</h3>
          <p>We could not preserve evidence for this URL. The capture may have failed, or the site blocked the request.</p>
          <button type="button" class="wc-btn wc-btn-outline" (click)="onBack()">
            <i class="bi bi-arrow-left"></i> Back to search
          </button>
        </div>
      </div>

      <ng-container *ngIf="!isLoading && captureData && !noResultsFound">
        <!-- Header -->
        <div class="wc-header">
          <div class="wc-header-meta-row">
            <div class="wc-header-left">
              <button type="button" class="wc-back-box" (click)="onBack()">
                <i class="bi bi-arrow-left"></i> Back
              </button>
            </div>
            <h1
              class="wc-page-title wc-page-title-center"
              [attr.title]="captureData.title || captureData.domain || 'Untitled capture'"
            >{{ captureData.title || captureData.domain || 'Untitled capture' }}</h1>
            <div class="wc-header-actions">
              <div class="dropdown">
                <button
                  type="button"
                  class="wc-export-button dropdown-toggle"
                  id="webCaptureExportDropdown"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                  [disabled]="exportingPdf || exportingZip"
                >
                  <i class="fas" [ngClass]="(exportingPdf || exportingZip) ? 'fa-spinner fa-spin' : 'fa-download'"></i>
                  <span class="wc-export-label">{{
                    exportingPdf ? 'Generating PDF...' : exportingZip ? 'Building ZIP...' : 'Export Report'
                  }}</span>
                </button>
                <ul class="dropdown-menu dropdown-menu-end" aria-labelledby="webCaptureExportDropdown">
                  <li>
                    <a class="dropdown-item wc-export-item" (click)="exportPdf()">
                      <i class="fas fa-file-pdf" aria-hidden="true"></i>
                      Export as PDF
                    </a>
                  </li>
                  <li>
                    <a class="dropdown-item wc-export-item" (click)="exportZip()">
                      <i class="fas fa-file-archive" aria-hidden="true"></i>
                      Export as ZIP
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <section class="wc-card wc-summary-card" aria-label="Capture summary">
          <div class="wc-url-row">
            <i class="fas fa-globe"></i>
            <a
              class="wc-url-link"
              [href]="historyMeta?.url || captureData.url"
              target="_blank"
              rel="noopener noreferrer"
              [title]="historyMeta?.url || captureData.url"
            >{{ historyMeta?.url || captureData.url }}</a>
            <button type="button" class="wc-icon-btn" (click)="copyUrl()" aria-label="Copy URL">
              <i class="fas" [ngClass]="copiedUrl ? 'fa-check text-success' : 'fa-copy'"></i>
            </button>
          </div>

          <div class="wc-quick-facts">
            <div class="wc-quick-fact">
              <span class="wc-qf-label"><i class="bi bi-calendar3"></i> Captured (UTC)</span>
              <span class="wc-qf-value">{{ capturedAt ? (capturedAt | date:'medium') : '—' }}</span>
            </div>
            <div class="wc-quick-fact">
              <span class="wc-qf-label"><i class="bi bi-geo-alt"></i> Resolved IP</span>
              <span class="wc-qf-value">{{ captureData.ipAddress || '—' }}</span>
            </div>
            <div class="wc-quick-fact">
              <span class="wc-qf-label"><i class="bi bi-hash"></i> HTTP status</span>
              <span class="wc-qf-value">{{ captureData.httpStatus ?? '—' }}</span>
            </div>
            <div class="wc-quick-fact">
              <span class="wc-qf-label"><i class="bi bi-hdd-network"></i> Server</span>
              <span class="wc-qf-value">{{ captureData.serverInfo || '—' }}</span>
            </div>
          </div>
        </section>

        <!-- Risk banner -->
        <div class="wc-card wc-risk-banner" *ngIf="scan" [ngClass]="'risk-' + riskLevel">
          <div class="wc-risk-left">
            <i class="bi bi-shield-check wc-risk-icon"></i>
            <div>
              <p class="wc-risk-kicker">URL threat assessment</p>
              <p class="wc-risk-title">{{ riskLabel }}</p>
            </div>
          </div>
          <div class="wc-risk-bar-wrap">
            <div class="wc-risk-bar-header">
              <span>Risk score</span>
              <span class="wc-risk-score">{{ riskScore }}/100</span>
            </div>
            <div class="wc-risk-bar">
              <div class="wc-risk-bar-fill" [style.width.%]="riskScore > 3 ? riskScore : 3"></div>
            </div>
          </div>
          <div class="wc-sev-pills">
            <div class="wc-sev-pill sev-critical"><span>{{ riskCounts.critical || 0 }}</span><small>Crit</small></div>
            <div class="wc-sev-pill sev-high"><span>{{ riskCounts.high || 0 }}</span><small>High</small></div>
            <div class="wc-sev-pill sev-medium"><span>{{ riskCounts.medium || 0 }}</span><small>Med</small></div>
            <div class="wc-sev-pill sev-low"><span>{{ riskCounts.low || 0 }}</span><small>Low</small></div>
          </div>
        </div>

        <!-- Failed warning -->
        <div class="wc-card wc-failed-banner" *ngIf="captureStatus === 'failed'">
          <i class="fas fa-exclamation-triangle"></i>
          <div>
            <p class="fw-semibold mb-1">Capture was incomplete</p>
            <p class="mb-0">Some artifacts could not be acquired. Partial evidence and any collected metadata are shown below.</p>
          </div>
        </div>

        <!-- Integrity hashes -->
        <div class="wc-hashes-section">
          <h2>
            <i class="fas fa-fingerprint"></i> Integrity hashes (SHA-256)
            <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
              <i class="far fa-question-circle"></i>
              <span class="wc-help-tip-text">{{ helpTips.integrityHashes }}</span>
            </span>
          </h2>
          <div class="wc-hash-grid">
            <div class="wc-hash-chip" *ngFor="let h of hashEntries" [class.is-highlight]="h.highlight">
              <span class="wc-hash-label">{{ h.label }}</span>
              <div class="wc-hash-value-row">
                <code class="wc-hash-value">{{ h.value }}</code>
                <button type="button" class="wc-icon-btn" (click)="copyHash(h.value)">
                  <i class="fas" [ngClass]="copiedHash === h.value ? 'fa-check text-success' : 'fa-copy'"></i>
                </button>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="wc-tabs-wrap">
          <div class="wc-tabs">
            <button type="button" class="wc-tab" *ngIf="scan" [class.active]="activeTab === 'scan'" (click)="setTab('scan')">
              <i class="fas fa-shield-alt"></i> Security scan
            </button>
            <button type="button" class="wc-tab" [class.active]="activeTab === 'screenshot'" (click)="setTab('screenshot')">
              <i class="fas fa-camera"></i> Screenshot
            </button>
            <button type="button" class="wc-tab" *ngIf="hasSelectors" [class.active]="activeTab === 'selectors'" (click)="setTab('selectors')">
              <i class="fas fa-crosshairs"></i> Selectors
              <span class="wc-tab-count">{{ selectors?.totalEntities || 0 }}</span>
            </button>
            <button type="button" class="wc-tab" *ngIf="hasIntel" [class.active]="activeTab === 'intel'" (click)="setTab('intel')">
              <i class="fas fa-satellite-dish"></i> Intelligence
            </button>
            <button type="button" class="wc-tab" *ngIf="isSocial" [class.active]="activeTab === 'social'" (click)="setTab('social')">
              <i class="fas fa-share-alt"></i> Social media
            </button>
            <button type="button" class="wc-tab" *ngIf="hasCrawl" [class.active]="activeTab === 'site'" (click)="setTab('site')">
              <i class="fas fa-layer-group"></i> Site mirror
              <span class="wc-tab-count">{{ sitePages.length }}</span>
            </button>
            <button type="button" class="wc-tab" [class.active]="activeTab === 'metadata'" (click)="setTab('metadata')">
              <i class="fas fa-network-wired"></i> Metadata
            </button>
            <button type="button" class="wc-tab" [class.active]="activeTab === 'source'" (click)="setTab('source')">
              <i class="fas fa-code"></i> Source
            </button>
            <button type="button" class="wc-tab" [class.active]="activeTab === 'links'" (click)="setTab('links')">
              <i class="fas fa-link"></i> Links
              <span class="wc-tab-count">{{ links.length }}</span>
            </button>
          </div>

          <!-- Security scan -->
          <div class="wc-tab-panel" *ngIf="activeTab === 'scan' && scan">
            <div class="wc-panel-grid-2 wc-scan-layout">
              <div class="wc-panel">
                <h4>
                  <i class="fas fa-shield-alt"></i> Threat findings
                  <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                    <i class="far fa-question-circle"></i>
                    <span class="wc-help-tip-text">{{ helpTips.threatFindings }}</span>
                  </span>
                  <span class="wc-panel-count">{{ sortedFindings.length }}</span>
                </h4>
                <div class="wc-panel-body">
                  <div class="wc-finding" *ngFor="let f of sortedFindings">
                    <div class="wc-finding-head">
                      <strong>{{ f.title }}</strong>
                      <span class="wc-sev-badge" [ngClass]="sevBadgeClass(f.severity)">{{ f.severity }}</span>
                    </div>
                    <p>{{ f.detail }}</p>
                    <span class="wc-finding-cat">{{ f.category }}</span>
                  </div>
                  <p class="wc-empty" *ngIf="!sortedFindings.length">No threat findings recorded.</p>
                </div>
              </div>
              <div class="wc-panel-stack" #scanStack>
                <div class="wc-panel">
                  <h4>
                    <i class="bi bi-shield-check"></i> Security headers
                    <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                      <i class="far fa-question-circle"></i>
                      <span class="wc-help-tip-text">{{ helpTips.securityHeaders }}</span>
                    </span>
                  </h4>
                  <div class="wc-panel-body">
                    <div class="wc-header-row" *ngFor="let h of securityHeaders">
                      <span class="wc-mono">{{ h.header }}</span>
                      <span class="wc-badge-ok" *ngIf="h.present"><i class="fas fa-check"></i> Present</span>
                      <span class="wc-badge-miss" *ngIf="!h.present"><i class="fas fa-exclamation-triangle"></i> Missing</span>
                    </div>
                  </div>
                </div>
                <div class="wc-panel">
                  <h4>
                    <i class="fas fa-arrow-right"></i> Redirect chain
                    <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                      <i class="far fa-question-circle"></i>
                      <span class="wc-help-tip-text">{{ helpTips.redirectChain }}</span>
                    </span>
                  </h4>
                  <div class="wc-panel-body">
                    <div class="wc-hop" *ngFor="let hop of redirectChain; let i = index">
                      <span class="wc-hop-num">{{ i + 1 }}</span>
                      <span class="wc-hop-status" [ngClass]="hopStatusClass(hop.status)">{{ hop.status ?? '—' }}</span>
                      <span class="wc-mono wc-hop-url">{{ hop.url }}</span>
                    </div>
                    <p class="wc-empty" *ngIf="!redirectChain.length">No redirects recorded.</p>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Screenshot -->
          <div class="wc-tab-panel" *ngIf="activeTab === 'screenshot'">
            <div class="wc-panel wc-panel-tall" *ngIf="screenshotSrc">
              <div class="wc-screenshot-meta">
                <span>Full-page screenshot<span *ngIf="captureData.screenshotWidth"> · {{ captureData.screenshotWidth }}×{{ captureData.screenshotHeight }}px</span></span>
                <button type="button" class="wc-link-btn" (click)="downloadScreenshot()"><i class="fas fa-download"></i> Download PNG</button>
              </div>
              <div class="wc-screenshot-wrap">
                <img [src]="screenshotSrc" [alt]="'Screenshot of ' + captureData.url" />
              </div>
            </div>
            <div class="wc-panel wc-empty-state" *ngIf="!screenshotSrc">
              <i class="fas fa-camera fa-2x"></i>
              <p>No screenshot captured</p>
            </div>
          </div>

          <!-- Selectors -->
          <div class="wc-tab-panel" *ngIf="activeTab === 'selectors' && hasSelectors">
            <div class="wc-panel wc-selectors-summary">
              <i class="fas fa-crosshairs"></i>
              <strong>Extracted selectors &amp; indicators</strong>
              <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                <i class="far fa-question-circle"></i>
                <span class="wc-help-tip-text">{{ helpTips.selectorsSummary }}</span>
              </span>
              <span class="wc-panel-count ml-auto">{{ selectors?.totalEntities || 0 }} indicators</span>
            </div>
            <div class="wc-panel" *ngIf="keywordHits.length">
              <h4>
                <i class="fas fa-tags"></i> Keyword watchlist hits
                <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                  <i class="far fa-question-circle"></i>
                  <span class="wc-help-tip-text">{{ helpTips.keywordHits }}</span>
                </span>
              </h4>
              <div class="wc-panel-body">
                <div class="wc-selector-row" *ngFor="let h of keywordHits">
                  <span class="wc-mono">{{ h.value }}</span>
                  <span class="wc-count-badge" *ngIf="h.count > 1">×{{ h.count }}</span>
                  <button type="button" class="wc-icon-btn" (click)="copyText(h.value)"><i class="fas fa-copy"></i></button>
                </div>
              </div>
            </div>
            <div class="wc-panel-grid-2">
              <div class="wc-panel" *ngFor="let group of selectorGroups">
                <h4><i class="fas" [ngClass]="group.icon"></i> {{ group.label }}</h4>
                <div class="wc-panel-body">
                  <div class="wc-selector-row" *ngFor="let h of group.hits">
                    <span class="wc-mono wc-selector-value">{{ h.value }}</span>
                    <span class="wc-count-badge" *ngIf="h.count > 1">×{{ h.count }}</span>
                    <div class="wc-selector-actions">
                      <button
                        *ngIf="canSearchSelector(group.searchType)"
                        type="button"
                        class="wc-search-btn"
                        (click)="searchSelector(group.searchType, h.value)"
                        [title]="'Search for ' + h.value"
                        [attr.aria-label]="'Search for ' + h.value"
                      >
                        <i class="fas fa-search"></i>
                      </button>
                      <button type="button" class="wc-icon-btn" (click)="copyText(h.value)" aria-label="Copy value">
                        <i class="fas fa-copy"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Intelligence -->
          <div class="wc-tab-panel" *ngIf="activeTab === 'intel' && hasIntel">
            <div class="wc-panel">
              <h4>
                <i class="fas fa-satellite-dish"></i> Threat-feed &amp; blocklist lookups
                <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                  <i class="far fa-question-circle"></i>
                  <span class="wc-help-tip-text">{{ helpTips.threatFeeds }}</span>
                </span>
              </h4>
              <div class="wc-panel-body">
                <div class="wc-threat-grid">
                  <div class="wc-threat-card" *ngFor="let f of threatFeeds" [ngClass]="threatBadgeClass(f.status)">
                    <div class="wc-threat-head"><strong>{{ f.source }}</strong><span>{{ f.status }}</span></div>
                    <p>{{ f.detail }}</p>
                  </div>
                </div>
                <p class="wc-empty" *ngIf="!threatFeeds.length">No threat-feed results.</p>
              </div>
            </div>
            <div class="wc-panel">
              <h4>
                <i class="fas fa-user-secret"></i> Brand-impersonation detection
                <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                  <i class="far fa-question-circle"></i>
                  <span class="wc-help-tip-text">{{ helpTips.brandImpersonation }}</span>
                </span>
              </h4>
              <div class="wc-panel-body">
                <ng-container *ngIf="brandImpersonation.detected; else noBrand">
                  <div class="wc-brand-head">
                    <strong class="text-capitalize">{{ brandImpersonation.brand }}</strong>
                    <span class="wc-sev-badge" [ngClass]="confidenceBadgeClass(brandImpersonation.confidence)">{{ brandImpersonation.confidence }} confidence</span>
                  </div>
                  <p *ngIf="brandImpersonation.legitimateDomains?.length" class="wc-muted">
                    Legitimate domain(s): <code>{{ brandImpersonation.legitimateDomains.join(', ') }}</code>
                  </p>
                  <ul class="wc-signal-list">
                    <li *ngFor="let s of brandImpersonation.signals"><i class="fas fa-exclamation-triangle"></i> {{ s }}</li>
                  </ul>
                </ng-container>
                <ng-template #noBrand><p class="wc-empty">No brand impersonation detected.</p></ng-template>
              </div>
            </div>
            <div class="wc-panel-grid-2">
              <div class="wc-panel">
                <h4>
                  <i class="fas fa-image"></i> Favicon
                  <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                    <i class="far fa-question-circle"></i>
                    <span class="wc-help-tip-text">{{ helpTips.favicon }}</span>
                  </span>
                </h4>
                <div class="wc-panel-body">
                  <ng-container *ngIf="favicon.found; else noFavicon">
                    <div class="wc-favicon-row">
                      <img *ngIf="favicon.url" [src]="favicon.url" alt="favicon" class="wc-favicon-img" />
                      <div>
                        <p class="wc-mono wc-muted">{{ favicon.url }}</p>
                        <p class="wc-muted">{{ favicon.bytes }} bytes</p>
                      </div>
                    </div>
                    <code *ngIf="favicon.hash" class="wc-hash-value d-block mt-2">{{ favicon.hash }}</code>
                  </ng-container>
                  <ng-template #noFavicon><p class="wc-empty">No favicon found.</p></ng-template>
                </div>
              </div>
              <div class="wc-panel">
                <h4>
                  <i class="fas fa-list-check"></i> Login-form targets
                  <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                    <i class="far fa-question-circle"></i>
                    <span class="wc-help-tip-text">{{ helpTips.loginForms }}</span>
                  </span>
                </h4>
                <div class="wc-panel-body">
                  <div class="wc-form-flags" *ngIf="formFlags.length">
                    <p *ngFor="let f of formFlags"><i class="fas fa-exclamation-triangle"></i> {{ f }}</p>
                  </div>
                  <div class="wc-form-card" *ngFor="let f of loginForms">
                    <div class="wc-form-tags">
                      <span class="wc-form-tag">{{ f.method }}</span>
                      <span class="wc-form-tag danger" *ngIf="f.hasPasswordField">password</span>
                      <span class="wc-form-tag" *ngIf="f.hasEmailField">email/user</span>
                      <span class="wc-form-tag warn" *ngIf="f.crossOrigin">cross-origin</span>
                      <span class="wc-form-tag danger" *ngIf="f.insecure">insecure</span>
                      <span class="wc-muted ms-auto">{{ f.fieldCount }} fields</span>
                    </div>
                    <p class="wc-mono wc-muted mb-0">→ {{ f.actionResolved || f.action || '(self)' }}</p>
                  </div>
                  <p class="wc-empty" *ngIf="!loginForms.length">No forms detected.</p>
                </div>
              </div>
            </div>
            <div class="wc-panel wc-similar-panel">
              <h4>
                <i class="fas fa-users"></i> Visually similar captures
                <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                  <i class="far fa-question-circle"></i>
                  <span class="wc-help-tip-text">{{ helpTips.similarCaptures }}</span>
                </span>
              </h4>
              <div class="wc-panel-body">
                <p class="wc-similar-phash" *ngIf="similarPhash">
                  Perceptual hash: <code>{{ similarPhash }}</code>
                </p>
                <p class="wc-empty" *ngIf="similarLoading">Comparing against your capture history…</p>
                <p class="wc-empty" *ngIf="!similarLoading && similarLoaded && !similarMatches.length">
                  No visually similar captures found in your history.
                </p>
                <div class="wc-similar-grid" *ngIf="!similarLoading && similarMatches.length">
                  <button
                    type="button"
                    class="wc-similar-card"
                    *ngFor="let m of similarMatches"
                    (click)="openSimilarCapture(m.id)"
                  >
                    <div class="wc-similar-thumb">
                      <img *ngIf="m.thumbnail" [src]="m.thumbnail" [alt]="m.domain || m.url" />
                      <div class="wc-similar-thumb-empty" *ngIf="!m.thumbnail">
                        <i class="fas fa-camera"></i>
                      </div>
                      <span class="wc-similar-badge">{{ m.similarity }}%</span>
                    </div>
                    <div class="wc-similar-meta">
                      <p class="wc-similar-domain">{{ m.domain || m.url }}</p>
                      <p class="wc-similar-ref">{{ m.reference }}</p>
                    </div>
                  </button>
                </div>
              </div>
            </div>
          </div>

          <!-- Social -->
          <div class="wc-tab-panel" *ngIf="activeTab === 'social' && isSocial">
            <div class="wc-panel">
              <h4>
                <i class="fas fa-share-alt"></i> Social media capture
                <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                  <i class="far fa-question-circle"></i>
                  <span class="wc-help-tip-text">{{ helpTips.socialMedia }}</span>
                </span>
              </h4>
              <div class="wc-kv"><span>Platform</span><span>{{ social.platformLabel || social.platform }}</span></div>
              <div class="wc-kv"><span>Handle</span><span>{{ social.handle || '—' }}</span></div>
              <div class="wc-kv"><span>Display name</span><span>{{ social.displayName || '—' }}</span></div>
              <div class="wc-kv"><span>Content type</span><span>{{ social.contentType || '—' }}</span></div>
              <div class="wc-kv"><span>Published</span><span>{{ social.publishedAt || '—' }}</span></div>
              <div class="wc-kv"><span>Canonical URL</span><span class="wc-mono">{{ social.canonicalUrl || '—' }}</span></div>
              <p class="mt-3" *ngIf="social.description">{{ social.description }}</p>
              <p class="mt-2" *ngIf="social.postText">{{ social.postText }}</p>
              <img *ngIf="social.imageUrl" [src]="social.imageUrl" alt="Social preview" class="wc-social-img mt-3" />
            </div>
          </div>

          <!-- Site mirror -->
          <div class="wc-tab-panel" *ngIf="activeTab === 'site' && hasCrawl">
            <div class="wc-mirror-stats">
              <div class="wc-mirror-stat"><span>Pages mirrored</span><strong>{{ crawlSummary?.pagesCrawled ?? sitePages.length }}</strong></div>
              <div class="wc-mirror-stat"><span>Max depth</span><strong>{{ crawlSummary?.maxDepthReached ?? 0 }}</strong></div>
              <div class="wc-mirror-stat"><span>Internal links</span><strong>{{ crawlSummary?.uniqueInternalLinks ?? 0 }}</strong></div>
              <div class="wc-mirror-stat"><span>Total size</span><strong>{{ fmtBytes(crawlSummary?.totalBytes) }}</strong></div>
            </div>
            <div class="wc-mirror-chips">
              <span>Images: {{ crawlAssets.images ?? 0 }}</span>
              <span>Scripts: {{ crawlAssets.scripts ?? 0 }}</span>
              <span>Stylesheets: {{ crawlAssets.stylesheets ?? 0 }}</span>
              <span>Documents: {{ crawlAssets.documents ?? 0 }}</span>
              <span>External links: {{ crawlSummary?.uniqueExternalLinks ?? 0 }}</span>
              <span class="warn" *ngIf="crawlSummary?.truncated">Crawl limit reached — partial mirror</span>
            </div>
            <div class="wc-panel wc-panel-tall">
              <h4><i class="fas fa-layer-group"></i> Mirrored pages <span class="wc-panel-count">{{ sitePages.length }}</span></h4>
              <div class="wc-mirror-page" *ngFor="let page of sitePages">
                <button type="button" class="wc-mirror-page-head" (click)="toggleMirrorPage(page)">
                  <span class="wc-depth-badge">D{{ page.depth }}</span>
                  <span class="wc-hop-status" [ngClass]="page.httpStatus < 400 ? 'hop-ok' : 'hop-error'">{{ page.httpStatus ?? 'ERR' }}</span>
                  <span class="wc-mono flex-grow-1 text-truncate">{{ page.url }}</span>
                  <span class="wc-muted d-none d-sm-inline">{{ fmtBytes(page.byteSize) }}</span>
                  <i class="fas fa-chevron-down" [class.rotated]="isMirrorOpen(page)"></i>
                </button>
                <div class="wc-mirror-page-body" *ngIf="isMirrorOpen(page)">
                  <div class="wc-kv"><span>Title</span><span>{{ page.title || '—' }}</span></div>
                  <div class="wc-kv"><span>Content type</span><span>{{ page.contentType || '—' }}</span></div>
                  <div class="wc-kv"><span>Links found</span><span>{{ page.linkCount ?? '—' }}</span></div>
                  <div class="wc-kv"><span>HTML SHA-256</span><span class="wc-mono">{{ page.htmlHash || '—' }}</span></div>
                  <details *ngIf="page.htmlSource" class="mt-2">
                    <summary>View preserved HTML</summary>
                    <pre class="wc-source-pre">{{ page.htmlSource }}</pre>
                  </details>
                </div>
              </div>
            </div>
          </div>

          <!-- Metadata -->
          <div class="wc-tab-panel" *ngIf="activeTab === 'metadata'">
            <div class="wc-panel-grid-2">
              <div class="wc-panel">
                <h4>
                  <i class="fas fa-lock"></i> SSL / TLS certificate
                  <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                    <i class="far fa-question-circle"></i>
                    <span class="wc-help-tip-text">{{ helpTips.ssl }}</span>
                  </span>
                </h4>
                <div class="wc-panel-body">
                  <ng-container *ngIf="ssl?.ok; else sslFail">
                    <div class="wc-kv"><span>Subject CN</span><span class="wc-link-value">{{ ssl.subject?.CN || '—' }}</span></div>
                    <div class="wc-kv"><span>Issuer</span><span>{{ (ssl.issuer?.O || '') + ' ' + (ssl.issuer?.CN || '') || '—' }}</span></div>
                    <div class="wc-kv"><span>Valid from</span><span>{{ ssl.validFrom || '—' }}</span></div>
                    <div class="wc-kv"><span>Valid to</span><span>{{ ssl.validTo || '—' }}</span></div>
                    <div class="wc-kv"><span>Days to expiry</span><span>{{ ssl.daysUntilExpiry ?? '—' }}</span></div>
                    <div class="wc-kv"><span>Protocol</span><span>{{ ssl.protocol || '—' }}</span></div>
                    <div class="wc-kv"><span>Serial</span><span class="wc-mono wc-kv-value-long">{{ ssl.serialNumber || '—' }}</span></div>
                    <div class="wc-kv"><span>SHA-256 FP</span><span class="wc-mono wc-kv-value-long">{{ ssl.fingerprint256 || '—' }}</span></div>
                    <div class="wc-kv"><span>Alt names</span><span class="wc-mono wc-kv-value-long">{{ sslAltNames }}</span></div>
                  </ng-container>
                  <ng-template #sslFail><p class="wc-empty">Not available: {{ ssl?.error || 'no certificate' }}</p></ng-template>
                </div>
              </div>
              <div class="wc-panel">
                <h4>
                  <i class="fas fa-network-wired"></i> DNS records
                  <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                    <i class="far fa-question-circle"></i>
                    <span class="wc-help-tip-text">{{ helpTips.dns }}</span>
                  </span>
                </h4>
                <div class="wc-panel-body">
                  <div class="wc-dns-row" *ngFor="let d of dnsLists">
                    <span class="wc-dns-label">{{ d.label }}</span>
                    <span class="wc-mono"><span *ngFor="let v of d.values" class="d-block">{{ v }}</span></span>
                  </div>
                  <p class="wc-empty" *ngIf="!dnsLists.length">No DNS records resolved.</p>
                </div>
              </div>
              <div class="wc-panel">
                <h4>
                  <i class="bi bi-shield-check"></i> WHOIS / registration
                  <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                    <i class="far fa-question-circle"></i>
                    <span class="wc-help-tip-text">{{ helpTips.whois }}</span>
                  </span>
                </h4>
                <div class="wc-panel-body">
                  <ng-container *ngIf="whois?.ok; else whoisFail">
                    <div class="wc-kv"><span>Registrar</span><span>{{ whois.registrar || '—' }}</span></div>
                    <div class="wc-kv"><span>Registered</span><span>{{ whois.registrationDate || '—' }}</span></div>
                    <div class="wc-kv"><span>Expires</span><span>{{ whois.expirationDate || '—' }}</span></div>
                    <div class="wc-kv"><span>Status</span><span>{{ (whois.status || []).join(', ') || '—' }}</span></div>
                    <div class="wc-kv"><span>Nameservers</span><span class="wc-kv-value-long">{{ (whois.nameservers || []).join(', ') || '—' }}</span></div>
                  </ng-container>
                  <ng-template #whoisFail><p class="wc-empty">Not available: {{ whois?.error || 'lookup failed' }}</p></ng-template>
                </div>
              </div>
              <div class="wc-panel">
                <h4>
                  <i class="fas fa-file-alt"></i> HTTP response headers
                  <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                    <i class="far fa-question-circle"></i>
                    <span class="wc-help-tip-text">{{ helpTips.httpHeaders }}</span>
                  </span>
                </h4>
                <div class="wc-panel-body">
                  <div class="wc-kv" *ngFor="let key of objectKeys(httpHeaders)">
                    <span>{{ key }}</span><span class="wc-mono wc-kv-value-long">{{ httpHeaders[key] }}</span>
                  </div>
                  <p class="wc-empty" *ngIf="!objectKeys(httpHeaders).length">No headers recorded.</p>
                </div>
              </div>
              <div class="wc-panel">
                <h4>
                  <i class="fas fa-code"></i> Meta tags
                  <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                    <i class="far fa-question-circle"></i>
                    <span class="wc-help-tip-text">{{ helpTips.metaTags }}</span>
                  </span>
                </h4>
                <div class="wc-panel-body">
                  <div class="wc-kv" *ngFor="let m of metaTags">
                    <span>{{ m.name }}</span><span class="wc-kv-value-long">{{ m.content }}</span>
                  </div>
                  <p class="wc-empty" *ngIf="!metaTags.length">No meta tags found.</p>
                </div>
              </div>
            </div>
          </div>

          <!-- Source -->
          <div class="wc-tab-panel" *ngIf="activeTab === 'source'">
            <div class="wc-panel wc-source-panel">
              <div class="wc-source-head">
                <h4>
                  <i class="fas fa-code"></i> HTML source
                  <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                    <i class="far fa-question-circle"></i>
                    <span class="wc-help-tip-text">{{ helpTips.htmlSource }}</span>
                  </span>
                </h4>
                <button type="button" class="wc-btn wc-btn-outline wc-btn-sm" (click)="copyHtmlSource()">
                  <i class="fas" [ngClass]="copiedHtml ? 'fa-check' : 'fa-copy'"></i> Copy
                </button>
              </div>
              <pre class="wc-source-pre" *ngIf="captureData.htmlSource">{{ captureData.htmlSource }}</pre>
              <p class="wc-empty" *ngIf="!captureData.htmlSource">No HTML source captured.</p>
            </div>
          </div>

          <!-- Links -->
          <div class="wc-tab-panel" *ngIf="activeTab === 'links'">
            <div class="wc-panel wc-panel-tall">
              <h4>
                <i class="fas fa-link"></i> Extracted links
                <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                  <i class="far fa-question-circle"></i>
                  <span class="wc-help-tip-text">{{ helpTips.extractedLinks }}</span>
                </span>
                <span class="wc-panel-count">{{ links.length }}</span>
              </h4>
              <div class="wc-link-row" *ngFor="let l of links">
                <span class="wc-link-badge" [class.ext]="l.external">{{ l.external ? 'EXT' : 'INT' }}</span>
                <span class="wc-mono">{{ l.href }}</span>
              </div>
              <p class="wc-empty" *ngIf="!links.length">No links found on the page.</p>
            </div>
          </div>
        </div>

        <!-- Notes -->
        <div class="wc-card wc-notes-card wc-notes-last">
          <div class="wc-notes-header">
            <h3>
              <i class="fas fa-sticky-note"></i> Investigator notes
              <span class="wc-help-tip" tabindex="0" aria-label="What is this?">
                <i class="far fa-question-circle"></i>
                <span class="wc-help-tip-text">{{ helpTips.investigatorNotes }}</span>
              </span>
            </h3>
            <button type="button" class="wc-btn wc-btn-primary wc-btn-sm" (click)="saveNotes()" [disabled]="savingNotes || !notesDirty">
              <i class="fas fa-save"></i> {{ savingNotes ? 'Saving…' : 'Save' }}
            </button>
          </div>
          <textarea
            class="wc-notes-input"
            rows="2"
            maxlength="20000"
            placeholder="Add investigation notes, context, or observations about this capture…"
            [(ngModel)]="notes"
          ></textarea>
        </div>
      </ng-container>
    </div>
  </div>
</div>
